/**
 * Each module quiz attempt gets a new question order.
 * Returns a copy so the course module's question list is left unchanged.
 * Pass false only when a caller must keep the authored order.
 */
export function orderModuleQuizQuestions(questions, shouldShuffle = true, random = Math.random) {
  const list = Array.isArray(questions) ? questions.map((question) => ({ ...question })) : []
  if (shouldShuffle === false || list.length < 2) return list
  for (let i = list.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1))
    const current = list[i]
    list[i] = list[j]
    list[j] = current
  }
  return list
}
